












































import { Component, Vue } from 'vue-property-decorator';
import LicenseList from '@/components/LicenseList.vue';
import TransactionList from '@/components/TransactionList.vue';
import { FORMAT_CURRENCY } from '@/utils/formatPrice';
import ModalArticles from '@/components/ModalArticles.vue';
import Loading from '@/components/Loading.vue';
import { ActionNames } from "@/constants/ActionNames";
import { GetterNames } from "@/constants/GetterNames";
import InvoiceList from '@/components/InvoiceList.vue';

@Component({
  components: {
    LicenseList,
    TransactionList,
    ModalArticles,
    Loading,
    InvoiceList,
  },
})
export default class Dashboard extends Vue {
  public loading: boolean = true;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public formatCurrency = (price: number): string => FORMAT_CURRENCY(price);

  get balance(): number {
    return this.$store.getters[GetterNames.BALANCE];
  }

  public async mounted() {
    const success = await this.$store.dispatch(ActionNames.GET_BALANCE);

    if (!success) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het ophalen van je tegoed',
      };
    }

    this.loading = false;
  }
}
